import React from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, Factory, Coins, Workflow, Snowflake, Flame,
  Thermometer, Leaf, Sparkles, Boxes, FlaskConical, Droplets,
  Activity, GitCompareArrows, History, GraduationCap, Package, Database,
} from "lucide-react";

const NAV = [
  { section: "Command" },
  { to: "/", label: "Enterprise Command", icon: LayoutDashboard, end: true },
  { to: "/process", label: "Process Mimic", icon: Factory },
  { to: "/economics", label: "Utility Economics", icon: Coins },
  { to: "/products", label: "Product Economics", icon: Package },
  { to: "/energy", label: "Energy Flow (MRI)", icon: Workflow },
  { section: "Digital Twins" },
  { to: "/twin/refrigeration", label: "Refrigeration", icon: Snowflake },
  { to: "/twin/boiler", label: "Boiler & Steam", icon: Flame },
  { to: "/twin/pasteurization", label: "Pasteurization", icon: Thermometer },
  { to: "/twins", label: "Twin Explorer", icon: Boxes },
  { to: "/assets", label: "Asset Health", icon: Activity },
  { section: "Intelligence" },
  { to: "/sustainability", label: "Sustainability", icon: Leaf },
  { to: "/ai", label: "AI Operations", icon: Sparkles },
  { section: "Operations" },
  { to: "/shadow", label: "Shadow Comparison", icon: GitCompareArrows },
  { to: "/replay", label: "History & Replay", icon: History },
  { to: "/simulation", label: "Simulation Studio", icon: FlaskConical },
  { to: "/training", label: "Operator Training", icon: GraduationCap },
  { to: "/db", label: "DB Inspector", icon: Database },
];

export default function Sidebar() {
  return (
    <aside className="w-[230px] shrink-0 bg-white border-r border-slate-200 h-screen sticky top-0 flex flex-col" data-testid="sidebar">
      <div className="px-4 py-4 border-b border-slate-100">
        <div className="flex items-center gap-2.5">
          <img src={`${process.env.PUBLIC_URL}/ergoniq-logo.svg`} alt="Ergoniq" className="h-12 w-auto" data-testid="brand-logo" />
          <div className="border-l border-slate-200 pl-2.5">
            <div className="text-sm font-bold text-slate-900 leading-tight">OIM</div>
            <div className="text-[10px] text-slate-500 leading-tight">Dairy Enterprise</div>
          </div>
        </div>
      </div>

      <nav className="flex-1 overflow-y-auto py-3 px-2.5 space-y-0.5">
        {NAV.map((item, i) =>
          item.section ? (
            <div key={i} className="px-2 pt-3 pb-1 text-[10px] font-bold uppercase tracking-[0.1em] text-slate-400">
              {item.section}
            </div>
          ) : (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={`nav-${item.to === "/" ? "home" : item.to.replace(/\//g, "-").replace(/^-/, "")}`}
              className={({ isActive }) =>
                `flex items-center gap-2.5 px-2.5 py-2 rounded-md text-[13px] font-medium transition-colors ${
                  isActive ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100"
                }`
              }
            >
              <item.icon size={16} />
              {item.label}
            </NavLink>
          )
        )}
      </nav>

      <div className="px-4 py-3 border-t border-slate-100 text-[10px] text-slate-400">
        Physics-First Economic Intelligence
      </div>
    </aside>
  );
}
